<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" show-total @on-change="changePage" @on-page-size-change="changePagesize" />
  </div>
</template>
<script>
export default {
  props: {
    inventoryId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      columns1: [
        {
          title: "领用编号",
          key: "id",
          width: 100,
          align: "center",
        },
        {
          title: "耗材名称",
          minWidth: 150,
          align: "center",
          render: (h, params) => {
            const row = params.row
            const text = row.name + row.model
            return <span style={{ 'font-size': '14px' }}>{text}</span>
          },
        },
        {
          title: "领用数量",
          minWidth: 80,
          key: "alterNum",
          align: "center",
        },
        {
          title: "领用人",
          key: "receive",
          minWidth: 100,
          align: "center",
        },
        {
          title: "领用科室",
          minWidth: 180,
          key: "desk",
          align: "center",
        },
        {
          title: "领用时间",
          minWidth: 180,
          key: "createTime",
          align: "center",
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
    let query = this.$route && this.$route.query;
    if ((query && query.inventoryId) || this.inventoryId) {
      // 设置查询参数
      this.query.inventoryId = (query && query.inventoryId) || this.inventoryId;
    }
  },
  mounted() {
    if (this.inventoryId) {
      this.load(this.inventoryId);
    }
  },
  methods: {
    load(inventoryId, page = 1) {
      let q = {};
      // let a = {}
      // a.inventoryId = inventoryId
      q.inventoryId = inventoryId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      q.orderByColumn = "createTime";
      q.isAsc = "descending";
      $utils.api
        .load("consumablesreceive", q)
        .then((res) => {
          if (res.code > 0) {
            let data = res.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }
        })
        .catch(() => {
          $utils.toast.error("请求错误");
        });
    },
    changePage(p) {
      this.load(this.inventoryId, p);
    },
    changePagesize(psize) { },
  },
};
</script>
